import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertReservationDocumentsNote } from 'modules/accommodations/features/reservations/api';

export const useMutationReservationDocumentsNote = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(upsertReservationDocumentsNote, {
    onSuccess: () => {
      successToast(t('You have successfully saved the note'));
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_CALCULATION_DOCUMENTS);
    },
    onError: () => errorToast(),
  });
};
